import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { CreateRequestReviewDocument, IRequestReviewDocument } from '../models/RequestReviewDocument';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

const LIMIT = 10;

export default class RequestReviewDocumentStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.reviewDocumentPages = 0;
                this.RequestReviewDocumentRegistry.clear();
            }
        )
    }

    RequestReviewDocumentRegistry = new Map();
    RequestReviewDocument: IRequestReviewDocument | null = null;
    NewRequestReviewDocument: CreateRequestReviewDocument | null = null;
    loadingInitialReviewDocuments = false;
    submitting = false;
    target = "";
    activeIndex = 0;

    requestReviewDocumentCount = 0;
    missingDocumentText = "";
    reviewDocumentPages = 0;
    docTypeSelectionDisabled = true;
    disabledDocumentTypes = new Array();
    limitedDocs = ["Self-Certification", "Port LOA", "Consent to Disclose"];

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.reviewDocumentPages ? this.reviewDocumentPages * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }


    get totalReviewDocumentNotePages() {
        return Math.ceil(this.requestReviewDocumentCount / LIMIT);
    }

    setPageReviewDocumentNotes = (reviewNotePages: number) => {
        this.reviewDocumentPages = reviewNotePages;
    }


    incrementRequestReviewDocumentNote = (id: string) => {
        let document = this.RequestReviewDocumentRegistry.get(id)
        document.noteCount += 1;
        this.RequestReviewDocumentRegistry.set(id, document)
    }



    get requestReviewDocumentsById() {
        return this.groupRequestReviewDocumentsById(Array.from(this.RequestReviewDocumentRegistry.values()));
    };


    getDocumentTypeCountInArray(DocumentType: string) {
        var documenttypes = Array.from(this.RequestReviewDocumentRegistry.values());

        var docTypeCount: number = 0;
        documenttypes.map(
            (value, index) => {
                if (value.documentType === DocumentType) {
                    docTypeCount++;
                }
            }
        )
        return docTypeCount;


    }


    groupRequestReviewDocumentsById(requestReviewDocuments: IRequestReviewDocument[]) {
        const sortedRequests = requestReviewDocuments.sort
        (
            (a, b) => (b.createdOn as any) - (a.createdOn as any)
        )

        return Object.entries(sortedRequests.reduce((requestReviewDocuments, requestReviewDocument) => {
            const id = requestReviewDocument.id;
            requestReviewDocuments[id] = requestReviewDocuments[id] ? [...requestReviewDocuments[id], requestReviewDocument] : [requestReviewDocument];
            return requestReviewDocuments;
        }, {} as { [key: string]: IRequestReviewDocument[] }));
    }

    CheckForUnAnsweredQuestions = () => {

        var result = true;
        var requestReviewDocumuments: IRequestReviewDocument[] = Array.from(this.RequestReviewDocumentRegistry.values());
        if (requestReviewDocumuments.length === 0) {
            this.missingDocumentText = "no Documents present"
            result = false;
        }
        requestReviewDocumuments.map((val, indx, list) => {
            if (val.questions.length === 0) {
                // this.rootStore.requestReviewDocumentAnswerStore.notComplete=true;
                this.missingDocumentText = "no Questions present"
                result = false;

            }
            else {
                val.questions.map((val2, indx2, list2) => {
                    if (val2.answer === null) {
                        this.missingDocumentText = "no questions answered on: " + val.documentType;
                        // this.rootStore.requestReviewDocumentAnswerStore.notComplete=true;
                        result = false;
                    }
                })
            }
        })
        return result;
    }

    get requestReviewDocumentsByDate() {
        return Array.from(this.RequestReviewDocumentRegistry.values()).sort(
            (a, b) => b.dateCreated - a.dateCreated
        );
    };

    loadRequestReviewDocuments = async (requestReviewId: string) => {
        this.RequestReviewDocumentRegistry.clear();
        this.loadingInitialReviewDocuments = true;
        this.disabledDocumentTypes = [];
        try {
            const requestReviewDocumentsEnvelope = await agent.RequestReviewDocuments.list(requestReviewId);
            const { requestReviewDocumentDTO, requestReviewDocumentCount } = requestReviewDocumentsEnvelope;
            let docCount = 1;
            runInAction('loadRequestReviewDocuments', () => {
                requestReviewDocumentDTO.forEach((requestReviewDocument) => {
                    if (this.limitedDocs.includes(requestReviewDocument.documentType)) {
                        this.disabledDocumentTypes.push(requestReviewDocument.documentType)
                    }
                    requestReviewDocument.docCount = docCount;
                    this.RequestReviewDocumentRegistry.set(requestReviewDocument.id, requestReviewDocument);
                    docCount++;
                });
                this.requestReviewDocumentCount = requestReviewDocumentCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadRequestReviewDocuments', () => {
            this.loadingInitialReviewDocuments = false;
            this.CheckForUnAnsweredQuestions();
        });
    };

    loadRequestReviewDocument = async (id: string) => {
        let RequestReviewDocument = this.getRequestReviewDocument(id);
        if (RequestReviewDocument) {
            this.RequestReviewDocument = RequestReviewDocument;
            return RequestReviewDocument;
        }
        else {
            this.loadingInitialReviewDocuments = true;
            try {
                RequestReviewDocument = await agent.RequestReviewDocuments.details(id);
                runInAction('getting activity', () => {
                    this.RequestReviewDocument = RequestReviewDocument;
                    this.RequestReviewDocumentRegistry.set(RequestReviewDocument.id, RequestReviewDocument);
                    this.loadingInitialReviewDocuments = false;
                })
                return RequestReviewDocument;
            } catch (error) {
                toast.error('problem submitting data');
            }
        }
        runInAction('loadRequestReviewDocuments', () => {
            this.loadingInitialReviewDocuments = false;
        });
    };

    getRequestReviewDocument = (id: string) => {
        return this.RequestReviewDocumentRegistry.get(id);
    }

    ClearRequestReviewDocument = () => {
        this.RequestReviewDocument = null;
    }

    CheckDocumentsRequirementFulfilled = () => {

        let passed: boolean = true;
        let missingNotes: string[] = [];

        const docs = Array.from(this.RequestReviewDocumentRegistry.values());
        docs.map((value: IRequestReviewDocument, index) => {
            if (value.noteRequired && value.noteCount === 0) {
                passed = false;
                missingNotes.push(value.documentType);
            }
        })
        let result: any = [passed, missingNotes]
        return result;
    }



    createRequestReviewDocument = async (requestReviewDocument: CreateRequestReviewDocument) => {
        this.submitting = true;
        try {
            let newDocument = await agent.RequestReviewDocuments.create(requestReviewDocument);
            runInAction('create RequestReviewDocument', () => {

                this.requestReviewDocumentCount = newDocument;
                this.RequestReviewDocumentRegistry.set(newDocument.id, newDocument);
                this.submitting = false;
            });
            toast.success('Created');
        } catch (error) {
            runInAction('create RequestReviewDocument error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editRequestReviewDocument = async (requestReviewDocument: IRequestReviewDocument) => {

    };

    deleteRequestReviewDocument = async (requestReviewDocumentId: string) => {
        this.submitting = true;
        try {
            await agent.RequestReviewDocuments.delete(requestReviewDocumentId);


            runInAction('create RequestReviewDocument', () => {
                this.submitting = false;
                this.RequestReviewDocumentRegistry.delete(requestReviewDocumentId);
            });
            toast.success('Saved');

        } catch (error) {
            runInAction('create RequestReviewDocument error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editRequestReviewDocument = async (requestReviewDocument: IRequestReviewDocument) => {

    };


}
decorate(RequestReviewDocumentStore, {
    RequestReviewDocumentRegistry: observable,
    RequestReviewDocument: observable,
    loadingInitialReviewDocuments: observable,
    submitting: observable,
    target: observable,
    requestReviewDocumentCount: observable,
    reviewDocumentPages: observable,
    predicate: observable,
    activeIndex: observable,
    missingDocumentText: observable,

    loadRequestReviewDocument: action,
    loadRequestReviewDocuments: action,
    CheckForUnAnsweredQuestions: action,
    ClearRequestReviewDocument: action,
    setPredicate: action,
    setPageReviewDocumentNotes: action,
    createRequestReviewDocument: action,
    editRequestReviewDocument: action,
    deleteRequestReviewDocument: action,
    getDocumentTypeCountInArray: action,
    incrementRequestReviewDocumentNote: action,
    CheckDocumentsRequirementFulfilled: action,

    requestReviewDocumentsById: computed,
    requestReviewDocumentsByDate: computed,
    axiosParams: computed,
    totalReviewDocumentNotePages: computed
});